<template>
    <div>
        <KidHeader :style="{ 'max-width': '575px', 'margin': '0 auto', 'padding-left': '15px', 'padding-right': '15px' }" :profileId="profileId" :serialNumber="serialNumber" />
        <div class="container-fluid">
            <div class="main-container">

                <!-- Back nav -->
                <div class="req-back" style="padding: 12px 14px 6px;">
                    <a v-if="!serialNumber" class="req-back__link" href="javascript:void(0)" @click="$router.push({ path: '/kids-device'})">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M19 12H5M5 12l7 7M5 12l7-7" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
                        Apps
                    </a>
                    <a v-else class="req-back__link" href="javascript:void(0)" @click="$router.push({ path: '/play-store', query: { profileId: this.profileId, serialNumber: this.serialNumber, playstoreText: this.playstoreText, filterCategory: this.filterCategory, ageFilter: this.ageFilter, expertRatingFilter: this.expertRatingFilter }})">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M19 12H5M5 12l7 7M5 12l7-7" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
                        Apps
                    </a>
                </div>

                <!-- Tabs -->
                <!-- Tabs -->
                <div class="ps-tabs">
                    <button
                        class="ps-tab"
                        :class="{ 'ps-tab--active': activeTab === 'usage' }"
                        @click="switchTab('usage')"
                    >Usage</button>
                    <button
                        class="ps-tab"
                        :class="{ 'ps-tab--active': activeTab === 'info' }"
                        @click="switchTab('info')"
                    >Info</button>
                    <button
                        class="ps-tab"
                        :class="{ 'ps-tab--active': activeTab === 'history' }"
                        @click="switchTab('history')"
                    >History</button>
                    <button
                        v-if="['com.android.chrome', 'com.google.android.youtube'].includes(package_name)"
                        class="ps-tab"
                        :class="{ 'ps-tab--active': activeTab === 'configuration' }"
                        @click="switchTab('configuration')"
                    >Configuration</button>
                </div>
                <div class="tab-content">

                    <!-- ── INFO TAB ── -->
                    <div v-show="activeTab === 'info'">
                        <div v-if="isLoading" class="ad-loader">
                            <i class="fa fa-spinner fa-spin"></i> Loading...
                        </div>
                        <div v-else-if="applicationDetail && applicationDetail.playStoreDetail">

                            <!-- Header image -->
                            <div v-if="applicationDetail.playStoreDetail.headerImage"
                                class="ad-hero"
                                :style="{ backgroundImage: 'url(' + applicationDetail.playStoreDetail.headerImage + ')' }">
                            </div>

                            <!-- App title row -->
                            <div class="ad-title-row">
                                <img :src="applicationDetail.playStoreDetail.icon" class="ad-title-icon" />
                                <div class="ad-title-info">
                                    <span class="ad-title-name">{{ applicationDetail.playStoreDetail.title }}</span>
                                    <span class="ad-title-price" v-if="applicationDetail.playStoreDetail.price > 0">₣ {{ applicationDetail.playStoreDetail.price }}</span>
                                </div>
                            </div>

                            <!-- Stats strip -->
                            <div class="ad-stats-strip">
                                <div class="ad-stat">
                                    <label class="ad-stat__val">
                                        <img v-if="applicationDetail.expertRating == 'EXPERT_RECOMMENDATION'" :src="exportGreen" height="20" />
                                        <img v-else-if="applicationDetail.expertRating == 'PARENTAL_SUPERVISION'" :src="exportOrange" height="20" />
                                        <img v-else-if="applicationDetail.expertRating == '16+'" :src="sixteenPlus" height="20" />
                                        <img v-else :src="notRated" height="20" />
                                    </label>
                                    <span class="ad-stat__label">Expert Rating</span>
                                </div>
                                <div class="ad-stat" v-if="applicationDetail.playStoreDetail.scoreText">
                                    <span class="ad-stat__val">
                                        <StarGoldIcon />
                                        <b>{{ applicationDetail.playStoreDetail.scoreText }}</b>
                                    </span>
                                    <span class="ad-stat__label">Google Play</span>
                                </div>
                                <div class="ad-stat">
                                    <span class="ad-stat__val">
                                        <img v-if="kidsRatingDetail.avgKidsRating >= 3" :src="childPositiveSmile" height="18" />
                                        <img v-else-if="kidsRatingDetail.avgKidsRating >= 2" :src="childNeutralSmile" height="18" />
                                        <img v-else-if="kidsRatingDetail.avgKidsRating >= 1" :src="childNegativeSmile" height="18" />
                                        <i v-else class="far fa-smile rating-grey"></i>
                                        <b> {{ overallRating }}</b>
                                    </span>
                                    <span class="ad-stat__label">Parents & Kids</span>
                                </div>
                                <div class="ad-stat" v-if="applicationDetail.playStoreDetail.contentRating">
                                    <span class="ad-stat__val"><b>{{ applicationDetail.playStoreDetail.contentRating }}</b></span>
                                    <span class="ad-stat__label">Age Group</span>
                                </div>
                                <div class="ad-stat">
                                    <span class="ad-stat__val"><b>{{ applicationDetail?.playStoreDetail?.genreId?.replace(/_/g, ' ').toLowerCase() }}</b></span>
                                    <span class="ad-stat__label">Category</span>
                                </div>
                            </div>

                            <!-- Rating popup -->
                            <div class="collapse mt-2 footer-full" id="reviewPopup">
                              <div class="rating-popup">
                                  <!-- Header -->
                                  <div class="rating-popup__header">
                                      <span class="rating-popup__title">Rate This App</span>
                                      <button class="ps-popup__close" @click="closeRatingPopup()">
                                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                              <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
                                          </svg>
                                      </button>
                                  </div>

                                  <div class="rating-popup__body" v-if="applicationDetail.appExist == true">

                                      <!-- App identity -->
                                      <div class="rating-popup__app-row">
                                          <img v-if="applicationDetail.playStoreDetail" :src="applicationDetail.playStoreDetail.icon" class="rating-popup__app-icon" />
                                          <img v-else :src="applicationDetail.app_icon" class="rating-popup__app-icon" />
                                          <span class="rating-popup__app-name">
                                              <b v-if="applicationDetail.playStoreDetail">{{ applicationDetail.playStoreDetail.title }}</b>
                                              <b v-else>{{ applicationDetail.package_name }}</b>
                                          </span>
                                      </div>

                                      <!-- Rating questions -->
                                      <div class="rating-popup__questions">

                                          <div class="rating-q">
                                              <span class="rating-q__label">Educational for your child?</span>
                                              <star-rating v-model:rating="isEducational" :show-rating="false" :star-size="28" />
                                          </div>

                                          <div class="rating-q">
                                              <span class="rating-q__label">Helps creativity?</span>
                                              <star-rating v-model:rating="isPositive" :show-rating="false" :star-size="28" />
                                          </div>

                                          <div class="rating-q">
                                              <span class="rating-q__label">Suitable content for age?</span>
                                              <star-rating v-model:rating="isSuitableContent" :show-rating="false" :star-size="28" />
                                          </div>

                                          <div class="rating-q">
                                              <span class="rating-q__label">Easy to navigate?</span>
                                              <star-rating v-model:rating="isEasyToUnderstand" :show-rating="false" :star-size="28" />
                                          </div>

                                          <!-- Recommend -->
                                          <div class="rating-q">
                                              <span class="rating-q__label">Recommend to other parents?</span>
                                              <div class="rating-q__thumb-row">
                                                  <button
                                                      class="rating-thumb-btn"
                                                      :class="{ 'rating-thumb-btn--active-no': isRecommend === false }"
                                                      @click="updateIsRecommend(false)"
                                                  >👎 No</button>
                                                  <button
                                                      class="rating-thumb-btn"
                                                      :class="{ 'rating-thumb-btn--active-yes': isRecommend === true }"
                                                      @click="updateIsRecommend(true)"
                                                  >👍 Yes</button>
                                              </div>
                                          </div>

                                          <!-- Comment -->
                                          <div class="rating-q">
                                              <span class="rating-q__label">Share your thoughts:</span>
                                              <textarea
                                                  class="rating-popup__textarea"
                                                  v-model="review"
                                                  rows="3"
                                                  placeholder="Help other parents with your comments..."
                                              ></textarea>
                                          </div>
                                      </div>

                                      <!-- Submit -->
                                      <div class="rating-popup__footer">
                                          <button
                                              class="req-action-btn req-action-btn--primary"
                                              :disabled="isDisabled"
                                              @click="submitParentRating()"
                                          >
                                              <span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i> Submitting...</span>
                                              <span v-else>Submit Rating</span>
                                          </button>
                                      </div>
                                  </div>
                              </div>
                          </div>

                            <!-- Install / Uninstall action -->
                            <div class="ad-action-row">
                                <div class="ad-action-warning" v-if="applicationDetail.playStoreDetail.free == false && applicationDetail.isAppInstalled == false">
                                    Paid apps cannot be installed through MDM unless purchased via an app management program.
                                </div>
                                <div v-if="applicationDetail.playStoreDetail.free == true">
                                    <button type="button" v-if="applicationDetail.isAppInstalled == false" class="req-action-btn req-action-btn--primary" @click="createProfileApplication(applicationDetail.playStoreDetail)">Install</button>
                                    <button type="button" v-else-if="applicationDetail.isSystemApp == false" class="req-action-btn req-action-btn--danger" @click="uninstallProfileApplication(this.package_name)" :disabled="isDisabled">
                                        <TrashIcon /> Uninstall
                                        <span v-if="isDisabled"><i class="fa fa-spinner fa-spin"></i></span>
                                    </button>
                                    <div class="ad-action-warning" v-else>This is a system app and cannot be uninstalled.</div>
                                </div>
                                <div class="ad-meta-tags" v-if="applicationDetail.playStoreDetail.adSupported == true || applicationDetail.playStoreDetail.offersIAP == true">
                                    <span class="ad-meta-tag" v-if="applicationDetail.playStoreDetail.adSupported">Contains Ads</span>
                                    <span class="ad-meta-tag" v-if="applicationDetail.playStoreDetail.offersIAP">In-App Purchases</span>
                                </div>
                            </div>

                            <!-- Accordion sections -->
                            <div class="ad-accordion">
                                <!-- App Images -->
                                <div class="ad-accordion__item">
                                    <button class="ad-accordion__btn" type="button" data-toggle="collapse" data-target="#collapseOne">
                                        <span>App Images</span>
                                        <svg class="ad-accordion__arrow" width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
                                    </button>
                                    <div id="collapseOne" class="collapse show">
                                        <div class="ad-screenshots">
                                            <img v-for="screenshot in applicationDetail.playStoreDetail.screenshots" :key="screenshot" :src="screenshot" class="ad-screenshot" />
                                        </div>
                                    </div>
                                </div>

                                <!-- Description -->
                                <div class="ad-accordion__item">
                                    <button class="ad-accordion__btn collapsed" type="button" data-toggle="collapse" data-target="#collapseTwo">
                                        <span>Description</span>
                                        <svg class="ad-accordion__arrow" width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
                                    </button>
                                    <div id="collapseTwo" class="collapse">
                                        <div class="ad-accordion__body">
                                            <p class="text-left" v-html="applicationDetail.playStoreDetail.descriptionHTML"></p>
                                        </div>
                                    </div>
                                </div>

                                <!-- Certificate -->
                                <div class="ad-accordion__item">
                                    <button class="ad-accordion__btn collapsed" type="button" data-toggle="collapse" data-target="#collapseThree">
                                        <span>Certificate</span>
                                        <div class="ad-accordion__right">
                                            <img v-if="applicationDetail.expertRating == 'EXPERT_RECOMMENDATION'" :src="exportGreen" height="15" />
                                            <img v-else-if="applicationDetail.expertRating == 'PARENTAL_SUPERVISION'" :src="exportOrange" height="15" />
                                            <img v-else-if="applicationDetail.expertRating == '16+'" :src="sixteenPlus" height="15" />
                                            <img v-else :src="notRated" height="15" />
                                            <svg class="ad-accordion__arrow" width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
                                        </div>
                                    </button>
                                    <div id="collapseThree" class="collapse">
                                        <div class="ad-accordion__body">
                                            <p class="text-left" v-if="applicationDetail.expertRatingComment" v-html="applicationDetail.expertRatingComment"></p>
                                            <p class="text-left" v-else>This app has not been certified yet by our expert team.</p>
                                        </div>
                                    </div>
                                </div>

                                <!-- Play Store Rating -->
                                <div class="ad-accordion__item">
                                    <button class="ad-accordion__btn collapsed" type="button" data-toggle="collapse" data-target="#collapseFour">
                                        <span>Play Store Rating</span>
                                        <div class="ad-accordion__right">
                                            <span class="ad-accordion__badge">
                                                <StarGoldIcon /> {{ applicationDetail.playStoreDetail.scoreText }}
                                            </span>
                                            <span class="ad-accordion__badge" v-if="applicationDetail.playStoreDetail.reviews">
                                                <CommentIcon /> {{ formatNumber(applicationDetail.playStoreDetail.reviews) }}
                                            </span>
                                            <svg class="ad-accordion__arrow" width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
                                        </div>
                                    </button>
                                    <div id="collapseFour" class="collapse">
                                        <div class="ad-accordion__body">
                                            <p class="text-left">See all reviews on Play Store: <a :href="applicationDetail.playStoreDetail.url" target="_blank">{{ applicationDetail.playStoreDetail.title }}</a></p>
                                        </div>
                                    </div>
                                </div>

                                <!-- Parents & Kids Rating -->
                                <div class="ad-accordion__item">
                                    <button class="ad-accordion__btn collapsed" type="button" data-toggle="collapse" data-target="#parentsKidsRating">
                                        <span>Parents & Kids Rating</span>
                                        <div class="ad-accordion__right">
                                            <span class="ad-accordion__badge">
                                                <img v-if="kidsRatingDetail.avgKidsRating >= 3" :src="childPositiveSmile" height="14" />
                                                <img v-else-if="kidsRatingDetail.avgKidsRating >= 2" :src="childNeutralSmile" height="14" />
                                                <img v-else-if="kidsRatingDetail.avgKidsRating >= 1" :src="childNegativeSmile" height="14" />
                                                <i v-else class="far fa-smile rating-grey"></i>
                                                {{ overallRating }}
                                            </span>
                                            <svg class="ad-accordion__arrow" width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
                                        </div>
                                    </button>
                                    <div id="parentsKidsRating" class="collapse">
                                        <div class="ad-accordion__body">
                                            <div class="ad-rating-header">
                                                <b>Help other parents</b>
                                                <button type="button" class="ps-install-btn" data-toggle="collapse" data-target="#reviewPopup">Rate This App</button>
                                            </div>
                                            <div class="parent-rating-section" v-if="parentsRatingDetail">
                                                <div class="ad-rating-section-title">
                                                    <b>Parents</b>
                                                    <span><b>{{ parentsRatingDetail.parentsRatingAvg }}</b> ({{ parentsRatingDetail.totalParentsRating }} Ratings)</span>
                                                </div>
                                                <div class="ad-rating-bars">
                                                    <div class="ad-rating-bar-row" v-for="(item, key) in [
                                                        { label: 'Educational', pct: parentsRatingDetail.educationalRatingPercentage, val: parentsRatingDetail.educationalRatingAvg },
                                                        { label: 'Supports Creativity', pct: parentsRatingDetail.positiveRatingPercentage, val: parentsRatingDetail.positiveRatingAvg },
                                                        { label: 'Suitable Content', pct: parentsRatingDetail.suitableRatingPercentage, val: parentsRatingDetail.suitableContentRatingAvg },
                                                        { label: 'Easy to Understand', pct: parentsRatingDetail.easyToUnderstaRatingPercentage, val: parentsRatingDetail.easyToUnderstandAvg },
                                                    ]" :key="key">
                                                        <span class="ad-rating-bar-label">{{ item.label }}</span>
                                                        <div class="ad-rating-bar-track">
                                                            <div class="ad-rating-bar-fill" :style="{ width: item.pct + '%' }"></div>
                                                        </div>
                                                        <span class="ad-rating-bar-val">{{ item.val }}</span>
                                                    </div>
                                                </div>
                                                <div class="ad-reviews-scroll">
                                                    <div class="ad-review-card" v-for="review in parentsRatingDetail.lastFiveReviews" :key="review._id">
                                                        <div class="ad-review-card__top">
                                                            <UserIcon />
                                                            <span class="ad-review-card__score">
                                                                <UsersBlueIcon />
                                                                <b>{{ ((review.isEducational + review.isPositive + review.isSuitableContent + review.isEasyToUnderstand) / 4).toFixed(1) }}</b>
                                                            </span>
                                                        </div>
                                                        <p class="ad-review-card__name" v-if="review.name">{{ review.name }} <span v-if="review.kidName">({{ review.kidName }})</span></p>
                                                        <p class="ad-review-card__text" v-if="review.review">{{ review.review }}</p>
                                                    </div>
                                                </div>
                                                <div class="ad-thumbs">
                                                    <b>Recommends to friends:</b>
                                                    <span><i class="fas fa-thumbs-up" style="color:gold"></i> {{ applicationDetail.upVoting }}</span>
                                                    <span><i class="fas fa-thumbs-down" style="color:gold"></i> {{ applicationDetail.downVoting }}</span>
                                                </div>
                                            </div>
                                            <hr>
                                            <div class="child-rating-section">
                                                <div class="ad-rating-section-title">
                                                    <b>Kids</b>
                                                    <span>
                                                        <img v-if="kidsRatingDetail.avgKidsRating >= 3" :src="childPositiveSmile" height="14" /> <b v-if="kidsRatingDetail.avgKidsRating >= 3"> Positive</b>
                                                        <img v-else-if="kidsRatingDetail.avgKidsRating >= 2" :src="childNeutralSmile" height="14" /> <b v-if="kidsRatingDetail.avgKidsRating >= 2 && kidsRatingDetail.avgKidsRating < 3"> Neutral</b>
                                                        <img v-else-if="kidsRatingDetail.avgKidsRating >= 1" :src="childNegativeSmile" height="14" /> <b v-if="kidsRatingDetail.avgKidsRating >= 1 && kidsRatingDetail.avgKidsRating < 2"> Negative</b>
                                                        ({{ kidsRatingDetail.totalKidsRating }} Ratings)
                                                    </span>
                                                </div>
                                                <div class="ad-rating-bars">
                                                    <div class="ad-rating-bar-row">
                                                        <span class="ad-rating-bar-label"><img :src="childPositiveSmile" height="13" /> Positive</span>
                                                        <div class="ad-rating-bar-track"><div class="ad-rating-bar-fill" style="background:#00C52B" :style="{ width: kidsRatingDetail.positiveRatingPercentage + '%' }"></div></div>
                                                        <span class="ad-rating-bar-val">{{ kidsRatingDetail.positiveRatingCount }}</span>
                                                    </div>
                                                    <div class="ad-rating-bar-row">
                                                        <span class="ad-rating-bar-label"><img :src="childNeutralSmile" height="13" /> Neutral</span>
                                                        <div class="ad-rating-bar-track"><div class="ad-rating-bar-fill" style="background:#737373" :style="{ width: kidsRatingDetail.naturalRatingPercentage + '%' }"></div></div>
                                                        <span class="ad-rating-bar-val">{{ kidsRatingDetail.naturalRatingCount }}</span>
                                                    </div>
                                                    <div class="ad-rating-bar-row">
                                                        <span class="ad-rating-bar-label"><img :src="childNegativeSmile" height="13" /> Negative</span>
                                                        <div class="ad-rating-bar-track"><div class="ad-rating-bar-fill" style="background:#ED0040" :style="{ width: kidsRatingDetail.negativeRatingPercentage + '%' }"></div></div>
                                                        <span class="ad-rating-bar-val">{{ kidsRatingDetail.negativeRatingCount }}</span>
                                                    </div>
                                                </div>
                                                <div class="ad-reviews-scroll">
                                                    <div class="ad-review-card" v-for="review in kidsRatingDetail.lastFiveReviews" :key="review._id">
                                                        <div class="ad-review-card__top">
                                                            <img :src="kidAvatar" width="24" height="auto" />
                                                            <span class="ad-review-card__score"><UsersBlueIcon /><b>{{ review.kidsRating }}</b></span>
                                                        </div>
                                                        <p class="ad-review-card__name" v-if="review.name">{{ review.name }} <span v-if="review.kidAge">({{ review.kidAge }} yr)</span></p>
                                                        <p class="ad-review-card__text" v-if="review.review">{{ review.review }}</p>
                                                        <p class="ad-review-card__date">{{ HumanReadableDateFormat(review.created_at, true) }}</p>
                                                    </div>
                                                </div>
                                                <div class="ad-thumbs">
                                                    <b>Recommends to friends:</b>
                                                    <span><i class="fas fa-thumbs-up" style="color:gold"></i> {{ kidsRatingDetail.upVoting }}</span>
                                                    <span><i class="fas fa-thumbs-down" style="color:gold"></i> {{ kidsRatingDetail.downVoting }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- What's New -->
                                <div class="ad-accordion__item">
                                    <button class="ad-accordion__btn collapsed" type="button" data-toggle="collapse" data-target="#collapseFive">
                                        <span>What's New</span>
                                        <div class="ad-accordion__right">
                                            <span class="ad-accordion__badge" v-if="applicationDetail.playStoreDetail">{{ timeSince(applicationDetail.playStoreDetail.updated) }}</span>
                                            <svg class="ad-accordion__arrow" width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
                                        </div>
                                    </button>
                                    <div id="collapseFive" class="collapse">
                                        <div class="ad-accordion__body">
                                            <p class="text-left" v-html="applicationDetail.playStoreDetail.recentChanges"></p>
                                        </div>
                                    </div>
                                </div>

                                <!-- App Privacy -->
                                <div class="ad-accordion__item">
                                    <button class="ad-accordion__btn collapsed" type="button" data-toggle="collapse" data-target="#collapseSix">
                                        <span>App Privacy</span>
                                        <svg class="ad-accordion__arrow" width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
                                    </button>
                                    <div id="collapseSix" class="collapse">
                                        <div class="ad-accordion__body">
                                            <a :href="applicationDetail.playStoreDetail.privacyPolicy" target="_blank" style="word-break:break-all; font-size:13px;">{{ applicationDetail.playStoreDetail.privacyPolicy }}</a>
                                        </div>
                                    </div>
                                </div>

                                <!-- Information -->
                                <div class="ad-accordion__item">
                                    <button class="ad-accordion__btn collapsed" type="button" data-toggle="collapse" data-target="#collapseSeven">
                                        <span>Information</span>
                                        <svg class="ad-accordion__arrow" width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
                                    </button>
                                    <div id="collapseSeven" class="collapse">
                                        <div class="ad-accordion__body" v-if="applicationDetail.playStoreDetail">
                                            <div class="ad-info-row" v-for="(item, i) in [
                                                { label: 'Provider', val: applicationDetail.playStoreDetail.developer },
                                                { label: 'Category', val: applicationDetail.playStoreDetail.genre },
                                                { label: 'Compatibility', val: applicationDetail.playStoreDetail.androidVersionText },
                                                { label: 'Age Rating', val: applicationDetail.playStoreDetail.contentRating },
                                                { label: 'In-App Purchase', val: applicationDetail.playStoreDetail.offersIAP ? 'Yes' : 'No' },
                                                { label: 'Copyright', val: applicationDetail.playStoreDetail.developerId },
                                            ]" :key="i">
                                                <span class="ad-info-row__label">{{ item.label }}</span>
                                                <span class="ad-info-row__val">{{ item.val }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="ad-error" v-else>Unable to fetch application detail from Play Store.</div>
                    </div>

                    <!-- ── USAGE TAB ── -->
                    <div v-show="activeTab === 'usage'">
                        <div v-if="isLoading" class="ad-loader">
                            <i class="fa fa-spinner fa-spin"></i> Loading...
                        </div>

                        <div v-else-if="applicationDetail?.appExist">
                            <div v-if="package_name != 'com.nova.kidsfirstphone'">

                                <!-- App header card -->
                                <div class="ad-app-card">
                                    <div class="ad-app-card__left">
                                        <img v-if="applicationDetail.playStoreDetail" :src="applicationDetail.playStoreDetail.icon" class="ad-app-card__icon" />
                                        <img v-else :src="applicationDetail.app_icon" class="ad-app-card__icon" />
                                        <div class="ad-app-card__info">
                                            <b v-if="applicationDetail.playStoreDetail">{{ applicationDetail.playStoreDetail.title }}</b>
                                            <b v-else>{{ applicationDetail.package_name }}</b>
                                        </div>
                                    </div>
                                    <div class="ad-app-card__right" v-if="!isProtectedApp(applicationDetail.package_name)">
                                        <span class="ad-app-card__status" :class="isAppEnabled ? 'ad-app-card__status--on' : 'ad-app-card__status--off'">
                                            {{ isAppEnabled ? 'Enabled' : 'Disabled' }}
                                            <span v-if="applicationDetail.is_app_disabled && applicationDetail.appEnabledDisabledType"> · {{ getReasonText(applicationDetail.appEnabledDisabledType) }}</span>
                                        </span>
                                        <label class="kid-action-switch">
                                            <input type="checkbox" v-model="isAppEnabled" @change="toggleAppStatus()" />
                                            <span class="kid-action-switch__track"></span>
                                        </label>
                                    </div>
                                </div>

                                <!-- Daily limit card -->
                                <div class="apps-card" style="margin: 8px 14px;">
                                    <div class="ad-limit-header">
                                        <span class="ad-limit-title">
                                            Daily Limit
                                            <a href="javascript:void(0)" @click="openDailyLimitPopup()" style="color:#6b7280; margin-left:4px;">
                                                <i class="fas fa-info-circle" style="font-size:13px;"></i>
                                            </a>
                                        </span>
                                        <label class="kid-action-switch">
                                            <input type="checkbox" v-model="enableDailyLimit" />
                                            <span class="kid-action-switch__track"></span>
                                        </label>
                                    </div>
                                    <div class="ad-limit-body">
                                        <span class="ad-limit-label">Minutes per day</span>
                                        <div class="req-popup__stepper">
                                            <button class="req-popup__step-btn" @click="decreaseLimit()"><ArrowLeftIcon /></button>
                                            <input
                                                type="text"
                                                class="req-popup__step-input"
                                                :readonly="enableDailyLimit == false"
                                                :class="{ 'text-warning': isDeliveredToDevice == false, 'text-success': isDeliveredToDevice == true }"
                                                v-model="dailyLimitTime"
                                                @change="onDailyLimitChange()"
                                            />
                                            <button class="req-popup__step-btn" @click="increaseLimit()"><ArrowRightIcon /></button>
                                        </div>
                                    </div>
                                    <!--<div style="padding: 0 14px 14px;">
                                        <button class="req-action-btn req-action-btn--primary" @click="updateDailyLimit()">Save</button>
                                    </div>-->
                                </div>
                            </div>

                            <!-- Activity section -->
                            <div class="activity-section" style="padding: 0 14px;">
                                <div class="activity-header">
                                    <div class="activity-header__top">
                                        <h5 class="activity-header__title">Activity</h5>
                                        <div class="activity-header__toggle">
                                            <button class="activity-toggle-btn" :class="{ 'activity-toggle-btn--active': filterType === 'Day' }" @click="changeFilterType('Day')">Day</button>
                                            <button class="activity-toggle-btn" :class="{ 'activity-toggle-btn--active': filterType === 'Week' }" @click="changeFilterType('Week')">Week</button>
                                        </div>
                                    </div>
                                    <div class="activity-nav" :data-filter-type="filterType">
                                        <button class="activity-nav__arrow" @click="previousDate()"><ArrowLeftIcon /></button>
                                        <span class="activity-nav__date">{{ formattedDate }}</span>
                                        <button class="activity-nav__arrow" @click="nextDate()"><ArrowRightIcon /></button>
                                        <div class="activity-nav__cal date-picker-wrapper">
                                            <label for="datePickerInput" class="date-picker-label">
                                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                                    <rect x="3" y="4" width="18" height="18" rx="3" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
                                                    <path d="M16 2v4M8 2v4M3 10h18" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/>
                                                </svg>
                                            </label>
                                            <input id="datePickerInput" ref="datePicker" type="date" v-model="selectedDate" @change="onDateChange" class="date-picker-input" />
                                        </div>
                                    </div>
                                </div>

                                <!-- Screen time card -->
                                <div class="screentime-card">
                                    <div class="screentime-card__header">
                                        <div class="screentime-card__left">
                                            <span class="screentime-card__label">Screen Time</span>
                                            <span class="screentime-card__value">{{ totalUsedTimeInFormat }}</span>
                                        </div>
                                    </div>
                                    <div class="screentime-card__body">
                                        <CanvasJSChart :options="options" :styles="styleOptions" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- App not installed — show install option -->
                        <div v-else-if="applicationDetail && applicationDetail.appExist === false">
                            <div class="ad-title-row">
                                <img :src="applicationDetail.playStoreDetail.icon" class="ad-title-icon" />
                                <div class="ad-title-info">
                                    <span class="ad-title-name">{{ applicationDetail.playStoreDetail.title }}</span>
                                </div>
                            </div>
                            <div class="ad-stats-strip">
                                <div class="ad-stat">
                                    <label class="ad-stat__val">
                                        <img v-if="applicationDetail.expertRating == 'EXPERT_RECOMMENDATION'" :src="exportGreen" height="20" />
                                        <img v-else-if="applicationDetail.expertRating == 'PARENTAL_SUPERVISION'" :src="exportOrange" height="20" />
                                        <img v-else-if="applicationDetail.expertRating == '16+'" :src="sixteenPlus" height="20" />
                                        <img v-else :src="notRated" height="20" />
                                    </label>
                                    <span class="ad-stat__label">Expert Rating</span>
                                </div>
                                <div class="ad-stat" v-if="applicationDetail.playStoreDetail.scoreText">
                                    <span class="ad-stat__val"><StarGoldIcon /><b>{{ applicationDetail.playStoreDetail.scoreText }}</b></span>
                                    <span class="ad-stat__label">Google Play</span>
                                </div>
                                <div class="ad-stat">
                                    <span class="ad-stat__val">
                                        <img v-if="kidsRatingDetail.avgKidsRating >= 3" :src="childPositiveSmile" height="18" />
                                        <img v-else-if="kidsRatingDetail.avgKidsRating >= 2" :src="childNeutralSmile" height="18" />
                                        <img v-else-if="kidsRatingDetail.avgKidsRating >= 1" :src="childNegativeSmile" height="18" />
                                        <i v-else class="far fa-smile rating-grey"></i>
                                        <b> {{ overallRating }}</b>
                                    </span>
                                    <span class="ad-stat__label">Parents & Kids</span>
                                </div>
                                <div class="ad-stat" v-if="applicationDetail.playStoreDetail.contentRating">
                                    <span class="ad-stat__val"><b>{{ applicationDetail.playStoreDetail.contentRating }}</b></span>
                                    <span class="ad-stat__label">Age Group</span>
                                </div>
                            </div>
                            <div class="ad-action-row">
                                <div class="ad-action-warning" v-if="applicationDetail.playStoreDetail.free == false">
                                    Paid apps cannot be installed through MDM unless purchased via an app management program.
                                </div>
                                <div v-if="applicationDetail.playStoreDetail.free == true">
                                    <button type="button" v-if="applicationDetail.isAppInstalled == false" class="req-action-btn req-action-btn--primary" @click="createProfileApplication(applicationDetail.playStoreDetail)">Install</button>
                                    <button type="button" v-else-if="applicationDetail.isSystemApp == false" class="req-action-btn req-action-btn--danger" @click="uninstallProfileApplication(this.package_name)" :disabled="isDisabled">
                                        <TrashIcon /> Uninstall
                                    </button>
                                    <div class="ad-action-warning" v-else>This is a system app and cannot be uninstalled.</div>
                                </div>
                                <div class="ad-meta-tags" v-if="applicationDetail.playStoreDetail.adSupported || applicationDetail.playStoreDetail.offersIAP">
                                    <span class="ad-meta-tag" v-if="applicationDetail.playStoreDetail.adSupported">Contains Ads</span>
                                    <span class="ad-meta-tag" v-if="applicationDetail.playStoreDetail.offersIAP">In-App Purchases</span>
                                </div>
                            </div>
                        </div>

                        <div class="ad-error" v-else>Something went wrong. Please try again later.</div>
                    </div>

                    <!-- ── HISTORY TAB ── -->
                    <div v-show="activeTab === 'history'">
                        <div class="ah-filters">
                            <button v-for="f in historyFilters" :key="f.value"
                                class="ah-chip" :class="{ 'ah-chip--active': historyFilter === f.value }"
                                @click="changeHistoryFilter(f.value)">{{ f.label }}</button>
                        </div>

                        <div v-if="historyLoading && !historyList.length" class="ad-loader">
                            <i class="fa fa-spinner fa-spin"></i> Loading...
                        </div>
                        <div v-else-if="!historyList.length" class="ah-empty">No history found for this app.</div>
                        <div v-else class="ah-list">
                            <div class="ah-item" v-for="item in historyList" :key="item._id">
                                <span class="ah-dot" :class="item.isEnabled ? 'ah-dot--on' : 'ah-dot--off'"></span>
                                <div class="ah-item__body">
                                    <div class="ah-item__title">{{ historyTitle(item) }}</div>
                                    <div class="ah-item__meta">
                                        {{ HumanReadableDateFormat(item.created_at) }}
                                        <span v-if="item.created_by"> · {{ item.created_by }}</span>
                                    </div>
                                </div>
                                <span class="ah-badge" :class="item.category === 'daily_limit' ? 'ah-badge--limit' : 'ah-badge--app'">
                                    {{ item.category === 'daily_limit' ? 'Daily Limit' : 'App' }}
                                </span>
                            </div>
                            <button v-if="historyHasMore" class="req-action-btn req-action-btn--primary" style="margin-top:10px" :disabled="historyLoading" @click="loadMoreHistory()">
                                <span v-if="historyLoading"><i class="fa fa-spinner fa-spin"></i></span>
                                <span v-else>Load more</span>
                            </button>
                        </div>
                    </div>

                    <!-- ── CONFIGURATION TAB ── -->
                    <div v-show="activeTab === 'configuration'" v-if="['com.android.chrome', 'com.google.android.youtube'].includes(package_name)">
                        <div style="padding: 14px;">
                            <AppConfigForm v-if="configSchema" :schema="configSchema" v-model="appConfig" />
                            <div class="save-row mt-3">
                                <button class="btn-save" :disabled="savingConfig" @click="saveAppConfig">
                                    <span v-if="savingConfig"><i class="fas fa-spinner fa-spin"></i> Saving...</span>
                                    <span v-else><i class="fas fa-save"></i> Save Settings</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Last updated -->
                <div class="last-updated">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" style="flex-shrink:0">
                        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="1.8"/>
                        <path d="M12 6v6l4 2" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
                    </svg>
                    Last updated: {{ lastUpdated }}
                </div>

                <!-- Daily limit info popup -->
                <div style="padding: 0 14px;">
                    <div class="collapse ps-popup-wrap" id="dailyLimitPopup">
                        <div class="ps-popup">
                            <div class="ps-popup__header">
                                <span class="ps-popup__title">Daily Limit</span>
                                <button class="ps-popup__close" @click="closeDailyLimitPopup()">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
                                </button>
                            </div>
                            <div class="ps-popup__body">
                                <p style="font-size:13px; color:#374151; line-height:1.6; margin:0 0 10px;">Once you set a daily limit, your child will only be able to use the app for the specified number of minutes each day.</p>
                                <div class="ad-legend">
                                    <div class="ad-legend__item"><span class="ad-legend__dot" style="background:#f59e0b;"></span> <span>Time limit sent to device</span></div>
                                    <div class="ad-legend__item"><span class="ad-legend__dot" style="background:#16a34a;"></span> <span>Time limit applied on device</span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Error Modal — unchanged -->
                <div class="modal fade" id="errorModal" tabindex="-1" role="dialog" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title text-danger">Error <i class="fas fa-exclamation-triangle"></i></h5>
                                <button type="button" class="close" data-dismiss="modal"><span>&times;</span></button>
                            </div>
                            <div class="modal-body">{{ error }}</div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-primary" v-if="categoryId" @click="gotToCategory()">Go To Category</button>
                                <button type="button" class="btn btn-primary" v-if="!categoryId" @click="gotToSetting()">Go To Setting</button>
                            </div>
                        </div>
                    </div>
                </div>

                <KidFooter :profileId="profileId" :serialNumber="serialNumber" />
            </div>
        </div>
    </div>
</template>
<script>
import ProfileService from "../../services/ProfileService";
import KidsService from "../../services/KidsService";
import StarRating from 'vue-star-rating'
import KidHeader from '@/components/KidHeader.vue'
import KidFooter from '@/components/KidFooter.vue'
import ArrowDownIcon from '@/components/icons/ArrowDownIcon.vue'
import UserIcon from '@/components/icons/UserIcon.vue'
import UsersBlueIcon from '@/components/icons/UsersBlueIcon.vue'
import ArrowLeftIcon from '@/components/icons/ArrowLeftIcon.vue'
import ArrowRightIcon from '@/components/icons/ArrowRightIcon.vue'
import ArrowLeftBackIcon from '@/components/icons/ArrowLeftBackIcon.vue'
import StarGoldIcon from '@/components/icons/StarGoldIcon.vue'
import CrossCloseIcon from '@/components/icons/CrossCloseIcon.vue'
import CommentIcon from '@/components/icons/CommentIcon.vue'
import TrashIcon from '@/components/icons/TrashIcon.vue'
import ThumbsUpIcon from '@/components/icons/ThumbsUpIcon.vue'
import HandIcon from '@/components/icons/HandIcon.vue'
import InfoCircleIcon from '@/components/icons/InfoCircleIcon.vue'
import AppConfigForm from '@/components/AppConfigForm.vue';
import { APP_CONFIG_SCHEMAS } from '@/config/appConfigSchemas.js';
let requestId = 0; // define this outside function (component-level)

export default {
  name: 'AppDetail',
  components: {
    AppConfigForm,
    KidHeader,
    KidFooter,
    StarRating,
    ArrowDownIcon,
    UserIcon,
    UsersBlueIcon,
    ArrowLeftIcon,
    ArrowRightIcon,
    ArrowLeftBackIcon,
    StarGoldIcon,
    CrossCloseIcon,
    CommentIcon,
    TrashIcon,
    ThumbsUpIcon,
    HandIcon,
    InfoCircleIcon
  },
  props: {
    notRated: {
        type: String,
        default: "./images/not-certified.png",
    },
    exportOrange: {
        type: String,
        default: "./images/experts-orange.png",
    },
    exportGreen: {
        type: String,
        default: "./images/experts-green.png",
    },
    sixteenPlus: {
        type: String,
        default: "./images/16-plus.png",
    },
    childPositiveSmile: {
        type: String,
        default: "./images/child-positive-smile.png",
    },
    childNeutralSmile:{
        type: String,
        default: "./images/child-neutral-smile.png",
    },
    childNegativeSmile:{
        type: String,
        default: "./images/child-negative-smile.png",
    },
    kidAvatar: {
      type: String,
      default: "./images/kids-avatar.png",
    }
  },
  computed: {
    // Returns the schema for the current app, or null if none defined
    configSchema() {
      return APP_CONFIG_SCHEMAS[this.package_name] || null;
    },
  },
  data() {
    return {
      profileDetail: null,
      isDisabled: false,
      package_name: this.$route.query.package_name,
      profileId: this.$route.query.profile_id,
      serialNumber: this.$route.query.serialNumber,
      playstoreText: this.$route.query.playstoreText,
      filterCategory: this.$route.query.filterCategory,
      expertRatingFilter: this.$route.query.expertRatingFilter,
      ageFilter: this.$route.query.ageFilter,
      applicationDetail: {},
      enableDailyLimit: false,
      dailyLimitTime: 0,
      isAppEnabled: false,
      currentDate: new Date(),
      activeTab: 'usage',
      formattedDate: new Date().toLocaleDateString("en-US", this.$dateOptions),
      options: null,
      styleOptions: {
        width: "100%",   
      },
      lastUpdated: "No data found.",
      deviceDetail: null,
      filterType: "Day",
      weekType: "Current",
      isEducational: 0,
      isPositive: 0,
      isSuitableContent: 0,
      isEasyToUnderstand: 0,
      review: "",
      isRecommend: null,
      isEasyToStop: null,
      isDeliveredToDevice: false,

      kidsRatingDetail: {},
      parentsRatingDetail: {},
      overallRating: 0,
      totalUsedTime: 0,
      totalUsedTimeInFormat: "",
      categoryId: null,
      error: "",
      appConfig: {},       // holds the live form values
      savingConfig: false,
      isLoading: true,
      protectedApps: [
        'com.samsung.android.app.contacts',
        'com.samsung.android.dialer',
        'com.samsung.android.messaging',
        'com.mywingio.dialer'
      ],
      selectedDate: '', // Add this line

      historyList: [],
        historyPage: 1,
        historyHasMore: false,
        historyLoading: false,
        historyLoaded: false,
        historyFilter: 'all',
        historyFilters: [
        { label: 'All', value: 'all' },
        { label: 'App Status', value: 'app_status' },
        { label: 'Daily Limit', value: 'daily_limit' },
        ],
    }
  },
  methods: {
    isProtectedApp(packageName) {
      return this.protectedApps.includes(packageName);
    },
    switchTab(tab) {
        this.activeTab = tab;
        if (tab === 'usage') {
            this.$nextTick(() => { this.getAppUsageChart(); });
        }
        if (tab === 'history' && !this.historyLoaded) {
            this.getAppHistory(true);
        }
    },
    async getAppHistory(reset = false) {
        if (reset) {
            this.historyPage = 1;
            this.historyList = [];
        }
        this.historyLoading = true;
        try {
            const response = await ProfileService.getApplicationDetail({
            profile_id: this.profileId,
            package_name: this.package_name,
            serialNumber: this.serialNumber,
            history_only: 'true',
            history_type: this.historyFilter,
            page: this.historyPage,
            limit: 20,
            });
            const list = response?.data?.history ?? [];
            this.historyList = reset ? list : [...this.historyList, ...list];
            this.historyHasMore = !!response?.data?.pagination?.hasMore;
            this.historyLoaded = true;
        } catch (e) {
            this.$toast.error(e?.response?.data?.respones_msg || "Failed to load history");
        } finally {
            this.historyLoading = false;
        }
        },
        loadMoreHistory() {
        this.historyPage++;
        this.getAppHistory();
        },
        changeHistoryFilter(value) {
        this.historyFilter = value;
        this.getAppHistory(true);
        },
        historyTitle(item) {
        if (item.category === 'daily_limit') {
            return item.isEnabled
            ? `Daily limit enabled${item.dailyLimitTime != null ? ' · ' + item.dailyLimitTime + ' min' : ''}`
            : 'Daily limit disabled';
        }
        return item.isEnabled ? 'Application enabled' : 'Application disabled';
        },
    async getApplicationDetail() {
      const currentRequestId = ++requestId;

      this.isLoading = true;

      const data = {
        profile_id: this.profileId,
        package_name: this.package_name,
        currentDate: this.currentDate,
        filterType: this.filterType,
        weekType: this.weekType,
        serialNumber: this.serialNumber,
      };

      try {
        const response = await ProfileService.getApplicationDetail(data);

        // 🚫 Ignore outdated responses
        if (currentRequestId !== requestId) return;

        const resData = response?.data?.data || {};

        // ✅ DO NOT reset applicationDetail before API completes
        this.applicationDetail = resData;
        if (this.historyLoaded) this.getAppHistory(true);

        this.profileDetail = response.data.profileDetail;
        this.kidsRatingDetail = response.data.kidsRating;
        this.overallRating = response.data.overallRating;
        this.parentsRatingDetail = response.data.parentRating;
        this.totalUsedTime = response.data.totalUsedTime;

        this.enableDailyLimit = resData.enableDailyLimit ?? false;
        this.dailyLimitTime = resData.dailyLimitTime || 0;

        this.isDeliveredToDevice = resData?.fcmDetail?.isDeviceAcknowledge ?? null;

        if (resData.appExist === true) {
          this.isAppEnabled = !resData.is_app_disabled;
        }

      } catch (e) {
        // 🚫 Ignore error if outdated request
        if (currentRequestId !== requestId) return;

        this.$toast.error(e?.response?.data?.respones_msg || "Something went wrong");
      } finally {
        // 🚫 Only stop loader if latest request
        if (currentRequestId === requestId) {
          this.isLoading = false;
        }
      }
    },
    updateDailyLimit() {
      if (this.enableDailyLimit == true && ! this.dailyLimitTime) {
        return this.$toast.error("Please enter time.");  
      }
      if (this.dailyLimitTime % 5 != 0 ) {
        return this.$toast.error("Please enter time multiple of 5.");   
      } 
      let data = {
        profile_id: this.profileId,
        package_name: this.package_name,
        dailyLimitTime: this.dailyLimitTime,
        enableDailyLimit: this.enableDailyLimit,
        serialNumber: this.serialNumber,
      }
      ProfileService.updateDailyLimit(data)
        .then((response) => {
          this.$toast.success(response.data.respones_msg);
          this.isDeliveredToDevice = false;
          if (response.data.data.triggerApplyPolicy) {
            if (this.profileDetail.profile_type == "Ios") {
                this.iosApplyPolicy()
            } else {
                this.applyPolicy();
            }
          }
          this.getApplicationDetail();
        }).catch((e) => {
          this.error = e.response.data.respones_msg;
          this.categoryId = e.response?.data?.data;
          if (this.categoryId) {
            $('#errorModal').modal('show');
          }
          if (e.response?.data?.showLimitErrorModal == true) {
            $('#errorModal').modal('show');
          }
          //this.$toast.error(e.response.data.respones_msg);
        });
    },
    gotToCategory() {
        $('#errorModal').modal('hide');
        this.$router.push({ path: '/category', query: { id: this.categoryId, profileId: this.profileId, serialNumber: this.serialNumber, appRequestPage: true }})
    },
    gotToSetting() {
      $('#errorModal').modal('hide');
      this.$router.push({ path: '/global-settings', query: { id: this.categoryId, profileId: this.profileId, serialNumber: this.serialNumber, appRequestPage: true }})
    },
    async createProfileApplication(app) {
        this.isDisabled = true;
        let masterApplicationData = {
            product_id: app.appId,
            package_name: app.appId,
            app_icon: app.icon,
            application_details: app,
            type: (this.profileDetail.profile_type == "Ios") ? "Ios" : "Android",
        };
        await ProfileService.createMasterApplication(masterApplicationData)
        .then((response) => {
        }).catch((e) => {
        })

      let data = {
        profile_id: this.profileId,
        package_name: app.appId,
        is_web_app: false,
        application_details: app,
        type: (this.profileDetail.profile_type == "Ios") ? "Ios" : "Android",
        serialNumber: this.serialNumber,
      };

      await ProfileService.createProfileApplication(data)
        .then((response) => {
            if (this.profileDetail.profile_type == "Ios") {
              this.iosApplyPolicy()
            } else {
              this.applyPolicy();
            }
            this.isDisabled = false;
            //this.$toast.success(response.data.respones_msg);
            this.getApplicationDetail();
        })
        .catch((e) => {
            this.isDisabled = false;
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    async uninstallProfileApplication(package_name) {
      this.isDisabled = true;
      var data = {
        package_name: package_name,
        profile_id: this.profileId,
        serialNumber: this.serialNumber
      };

      await ProfileService.uninstallProfileApplication(data)
        .then(async (response) => {
            if (this.profileDetail.profile_type == "Ios") {
              this.iosApplyPolicy()
            } else {
              await this.applyPolicy();
            }
            
            this.deleteProfileApplication(package_name);
            this.isDisabled = false;
            //this.$toast.success(response.data.respones_msg);
        }).catch((e) => {
          this.isDisabled = false;
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    deleteProfileApplication(package_name) {
        if (package_name == "com.nova.kidsfirstphone") {
          this.$toast.error("You don't have permission to uninstall this app");
          return;
        } 
        this.isDisabled = true;
        var data = {
          package_name: package_name,
          profile_id: this.profileId,
          serialNumber: this.serialNumber
        };

        ProfileService.deleteProfileApplication(data)
          .then((response) => {
              if (this.profileDetail.profile_type == "Ios") {
                this.iosApplyPolicy()
              } else {
                 this.applyPolicy();
              }
              this.isDisabled = false;
              //this.$toast.success(response.data.respones_msg);
              this.getApplicationDetail();
          })
          .catch((e) => {
            this.isDisabled = false;
            this.$toast.error(e.response.data.respones_msg);
          });
    },

    iosApplyPolicy() {
          this.isDisabled = true;
          let data = {
            profile_id: this.profileId,
          }
          ProfileService.iosApplyPolicy(data)
          .then((response) => {
            //this.$toast.success(response.data.respones_msg);
            this.isDisabled = false;
          }).catch((e) => {
            this.$toast.error(e.response.data.respones_msg);
            this.isDisabled = false;
            /*if (e.response.data.data.payment_redirection) {
              this.$router.push({ path: 'plan-list'})
            }*/
          });
    },

    async applyPolicy() {
      this.isDisabled = true;
      let data = {
        profile_id: this.profileId,
        serialNumber: this.serialNumber
      };

      await ProfileService.applyPolicy(data)
        .then((response) => {
          this.isDisabled = false;
        })
        .catch((e) => {
          this.isDisabled = false;
          //this.$toast.error(e.response.data.respones_msg);
        });
    },

    async getAppUsageChart() {
        let data = {
        profileId: this.profileId,
        serialNumber: this.serialNumber,
        packageName: this.package_name,
        currentDate: this.currentDate,
        filterType: this.filterType,
        weekType: this.weekType
      }
      await KidsService.getAppUsageChart(data)
        .then((response) => {
            this.options = response.data.data
            this.deviceDetail = response.data.deviceDetail;
            if (this.deviceDetail && this.deviceDetail.lastDeviceActivationDate) {
                this.lastUpdated = new Date(this.deviceDetail.lastDeviceActivationDate).toLocaleDateString("en-US", this.$dateOptions) + " " + new Date(this.deviceDetail.lastDeviceActivationDate).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})
            } else {
                this.lastUpdated = "No data found.";
            }
            this.totalUsedTimeInFormat = response.data.totalUsedTimeInFormat;
        }).catch((e) => {
          this.$toast.error(e);
        });
    },
    onDateChange() {
        if (this.selectedDate) {
            const parts = this.selectedDate.split('-');
            const year = parseInt(parts[0]);
            const month = parseInt(parts[1]) - 1;
            const day = parseInt(parts[2]);
            
            this.currentDate = new Date(year, month, day);
            this.formattedDate = this.currentDate.toLocaleDateString("en-US", this.$dateOptions);
            
            this.getAppUsageChart();
        }
    },

    formatDateForInput(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    },
    changeFilterType(type) {
        this.filterType = type;
        if (this.filterType == "Day") {
            this.formattedDate = this.currentDate.toLocaleDateString("en-US", this.$dateOptions);
            this.selectedDate = this.formatDateForInput(this.currentDate); // Add this line
        } else {
            this.formattedDate = "This Week";
            this.weekType = "Current";
            this.selectedDate = ''; // Add this line
        }
    },
    previousDate() {
      if (this.filterType == "Day") {
        let day = this.currentDate.getTime() - (1 * 24 * 60 * 60 * 1000);
        this.currentDate.setTime(day);
        this.formattedDate = this.currentDate.toLocaleDateString("en-US", this.$dateOptions);
        this.selectedDate = this.formatDateForInput(this.currentDate); // Add this line
      } else {
          this.formattedDate = "Previous Week"
          this.weekType = "Previous";
      }
      this.getAppUsageChart();
    },
    nextDate() {
      if (this.filterType == "Day") {
        let day = this.currentDate.getTime() + (1 * 24 * 60 * 60 * 1000);
        this.currentDate.setTime(day);
        this.formattedDate = this.currentDate.toLocaleDateString("en-US", this.$dateOptions)
        this.selectedDate = this.formatDateForInput(this.currentDate); // Add this line
      } else {
        this.formattedDate = "This Week",
        this.weekType = "Current";    
      }  
      this.getAppUsageChart();
    },
    closeRatingPopup() {
        $('#reviewPopup').collapse('hide');
    },
    updateIsEasyToStop(value) {
      this.isEasyToStop = value;
    },
    updateIsRecommend(value) {
      this.isRecommend = value;
    },
    submitParentRating() {
      this.isDisabled = true;
      let data = {
        packageName: this.package_name,
        isEducational: this.isEducational,
        isPositive: this.isPositive,
        isEasyToStop: this.isEasyToStop,
        isSuitableContent:this.isSuitableContent,
        isEasyToUnderstand: this.isEasyToUnderstand,
        isRecommend: this.isRecommend,
        review: this.review,
        profileId: this.profileId
      };

      KidsService.submitParentRating(data)
        .then((response) => {
          this.isDisabled = false;
          this.getApplicationDetail();
          $('#reviewPopup').collapse('hide');
          //this.$toast.success(response.data.respones_msg);
        }).catch((e) => {
          this.isDisabled = false;
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    updateAppRecommendations(isRecommended) {
      this.isDisabled = true;
      let data = {
        packageName: this.package_name,
        isRecommend: isRecommended,
      };

      KidsService.updateAppRecommendations(data)
        .then((response) => {
          this.isDisabled = false;
          this.getApplicationDetail();
          //this.$toast.success(response.data.respones_msg);
        }).catch((e) => {
          this.isDisabled = false;
          this.$toast.error(e.response.data.respones_msg);
        });
    },

    toggleAppStatus() {
      if (this.enableDailyLimit == true && this.isAppEnabled == true && this.totalUsedTime >= this.dailyLimitTime) {
          this.isAppEnabled = false;
          return this.$toast.error("Please increase daily limit time to enable this category.");  
      }
      var data = {
          application_id: this.applicationDetail._id,
          is_app_disabled: (this.isAppEnabled == true) ? false : true,
          serialNumber: this.serialNumber  
        };

        ProfileService.toggleProfileAppStatus(data)
          .then((response) => {
              this.isDisabled = false;
              //this.$toast.success(response.data.respones_msg);
              if (this.profileDetail.profile_type == "Ios") {
                    this.iosApplyPolicy()
              } else {
                    this.applyPolicy();
              }
              this.getApplicationDetail();
          })
          .catch((e) => {
            this.isDisabled = false;
            this.$toast.error(e.response.data.respones_msg);
          });
    },

    timeSince(previous) {
      var msPerMinute = 60 * 1000;
      var msPerHour = msPerMinute * 60;
      var msPerDay = msPerHour * 24;
      var msPerMonth = msPerDay * 30;
      var msPerYear = msPerDay * 365;
      let current = Date.now();
      var elapsed = current - previous;

      if (elapsed < msPerMinute) {
          return Math.round(elapsed/1000) + ' seconds ago';   
      }

      else if (elapsed < msPerHour) {
          return Math.round(elapsed/msPerMinute) + ' minutes ago';   
      }

      else if (elapsed < msPerDay ) {
          return Math.round(elapsed/msPerHour ) + ' hours ago';   
      }

      else if (elapsed < msPerMonth) {
          return Math.round(elapsed/msPerDay) + ' days ago';   
      }

      else if (elapsed < msPerYear) {
          return Math.round(elapsed/msPerMonth) + ' months ago';   
      }

      else {
          return Math.round(elapsed/msPerYear ) + ' years ago';   
      }

    },
    formatNumber(number) {
      const formatCash = Intl.NumberFormat('en-US', {
        notation: "compact",
        maximumFractionDigits: 1
      }).format(number);
      return formatCash;
    },
    decreaseLimit() {
        if (this.dailyLimitTime > 0) {
            this.dailyLimitTime = this.dailyLimitTime - 5
            if (this.dailyLimitTime == 0) {
              this.enableDailyLimit = false;      
            }
        } else {
          this.enableDailyLimit = false;  
        }
        this.updateDailyLimit();
    },
    increaseLimit() {
        this.enableDailyLimit = true;
        this.dailyLimitTime = (parseInt(this.dailyLimitTime) + 5)
        this.updateDailyLimit();
    },
    openDailyLimitPopup() {
        $('#dailyLimitPopup').collapse('show')
    }, 
    closeDailyLimitPopup(){
        $('#dailyLimitPopup').collapse('hide')
    },
    roundOF15() {
        const value = parseInt(this.dailyLimitTime);
        this.dailyLimitTime = (isNaN(value) || value < 0) ? 0 : Math.ceil(value / 5) * 5;
    },
    onDailyLimitChange() {
        this.roundOF15();

        // 0 means turn the limit off. The enableDailyLimit watcher resets the value
        // and calls updateDailyLimit(), so return here to avoid a double call.
        if (this.dailyLimitTime <= 0) {
            this.enableDailyLimit = false;
            return;
        }

        // Skip if rounding brought it back to the saved value (avoids a useless audit log entry)
        if (this.dailyLimitTime === (this.applicationDetail?.dailyLimitTime ?? 0)) return;

        this.updateDailyLimit();
    },
    HumanReadableDateFormat(date, onlyDate = false) {
        const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "June",
        "July", "Aug", "Sept", "Oct", "Nov", "Dec"
        ];
        let dt = new Date(date);
        if (dt == "Invalid Date") {
            return "-";
        }
        let day = ("0" + dt.getDate()).slice(-2);
        let month = dt.getMonth();
        let year = dt.getFullYear();
        let hour = ("0" + dt.getHours()).slice(-2);
        let minute = ("0" + dt.getMinutes()).slice(-2);
        let seconds = ("0" + dt.getSeconds()).slice(-2);
        if (onlyDate) {
            return month + "/" + year;
        } else {
            return day + " " + monthNames[month] + " " + year + " " + hour + ":" + minute + ":" + seconds;
        }
    },
    
    getReasonText(type) {
      switch (type) {
        case 'Manually':
          return 'manually';
        case 'Overuse':
          return 'due to app time limit';
        case 'Category Overuse':
          return 'due to category time limit';
        case 'Cronjob':
          return 'via schedule';
        case 'Global Daily Limit Reach':
          return 'due to device time limit';
        default:
          return type;
      }
    },

  async getChromeManageConfig() {
      this.loadingConfig = true;
      const data = {
        serialNumber: this.serialNumber,
        profileId:    this.profileId,
        package_name: this.package_name,
      };

      await KidsService.getChromeManageConfig(data)
        .then((response) => {
          // Call loadAppConfig to hydrate appConfig with defaults + saved values
          this.loadAppConfig(response.data.data);
        })
        .catch((e) => {
          this.$toast.error(e?.response?.data?.respones_msg || 'Failed to load configuration');
        })
        .finally(() => {
          this.loadingConfig = false;
        });
    },
    loadAppConfig(apiData) {
      if (!this.configSchema) return;

      // Get the config key dynamically based on package
      const CONFIG_KEY_MAP = {
        'com.android.chrome': 'chromeManagedConfiguration',
        'com.google.android.youtube': 'chromeManagedConfiguration',
        // add more packages here as needed
      };

      const configKey = CONFIG_KEY_MAP[this.package_name];
      const savedConfig = configKey ? (apiData?.[configKey] || {}) : {};

      // Start from schema defaults, then overlay saved API values
      this.appConfig = {
        ...this.configSchema.defaultValues,
        ...savedConfig,
      };
    },

    async saveAppConfig() {
      this.savingConfig = true;
      try {
        await KidsService.saveChromeManageConfig({
          serialNumber: this.serialNumber,
          profileId:    this.profileId,
          chromeManagedConfiguration: this.appConfig,
          package_name: this.package_name
        });
        await ProfileService.applyPolicy({ profile_id: this.profileId, serialNumber: this.serialNumber });
        //this.$toast.success('Settings saved successfully!');
      } catch (e) {
        this.$toast.error(e?.response?.data?.respones_msg || 'Failed to save');
      } finally {
        this.savingConfig = false;
      }
    },
  },
  watch: {
    enableDailyLimit() {
        if (this.enableDailyLimit == false) {
          this.dailyLimitTime = 0
        } else {
          this.dailyLimitTime = (this.applicationDetail.dailyLimitTime > 0 ) ? this.applicationDetail.dailyLimitTime : 15;
        }
        this.updateDailyLimit();
    },
    
    dailyLimitTime() {
        if (this.dailyLimitTime < 0) {
            this.dailyLimitTime = 0;
        }
    },
    filterType() {
        this.getAppUsageChart();
    }
  },
  beforeMount() {
    this.selectedDate = this.formatDateForInput(this.currentDate); // Add this line
    this.getApplicationDetail();
    this.getAppUsageChart();
    const packages = [
      "com.android.chrome",
      "com.google.android.youtube"
    ];

    if (packages.includes(this.package_name)) {
      this.getChromeManageConfig();
    }
    let showRating = this.$route.query.showRating;
    if (showRating == 'true') {
      setTimeout(function() {
          $('#reviewPopup').collapse('show');
      }, 2500); 
    }
  }, 
}
</script>
<style scoped>
/* ── Back nav ── */
.req-back__link {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    font-weight: 600;
    color: #374151;
    text-decoration: none;
    -webkit-tap-highlight-color: transparent;
}

/* ── Tabs ── */
.ps-tabs {
    display: flex;
    padding: 0 14px;
    border-bottom: 0.5px solid #e5e7eb;
    margin-bottom: 0;
    gap: 0;
    text-align: left;
    width: 100%;
}

.ps-tab {
    padding: 11px 16px 10px;
    font-size: 13px;
    font-weight: 500;
    color: #6b7280;
    text-decoration: none;
    border: none;
    background: none;
    border-bottom: 2.5px solid transparent;
    margin-bottom: -0.5px;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    transition: color 0.15s, border-color 0.15s;
}

.ps-tab--active {
    color: #2563eb;
    font-weight: 700;
    border-bottom-color: #2563eb;
}
/* ── Loader / error ── */
.ad-loader { text-align: center; padding: 32px; color: #6b7280; font-size: 14px; }
.ad-error { padding: 20px 14px; color: #dc2626; font-size: 13px; }

/* ── Hero image ── */
.ad-hero {
    width: 100%;
    height: auto;
    max-height: 200px;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    background-color: #f3f4f6;
    aspect-ratio: 16/9;
}

/* ── App title row ── */
.ad-title-row {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 14px 10px;
}
.ad-title-icon { width: 48px; height: 48px; border-radius: 12px; flex-shrink: 0; }
.ad-title-info { display: flex; flex-direction: column; gap: 2px; }
.ad-title-name { font-size: 16px; font-weight: 700; color: #111; }
.ad-title-price { font-size: 13px; color: #6b7280; }

/* ── Stats strip ── */.ad-stats-strip {
    display: flex;
    gap: 0;
    padding: 12px 0;
    border-top: 0.5px solid #f3f4f6;
    border-bottom: 0.5px solid #f3f4f6;
    overflow-x: auto;
    scrollbar-width: none;
    -webkit-overflow-scrolling: touch;
}

.ad-stats-strip::-webkit-scrollbar { display: none; }

.ad-stat {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 5px;
    flex: 1;
    min-width: 70px;
    padding: 8px 6px;
    border-right: 0.5px solid #f3f4f6;
    text-align: center;
}

.ad-stat:last-child { border-right: none; }

.ad-stat__val {
    font-size: 13px;
    font-weight: 600;
    color: #111;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 3px;
    min-height: 22px;
}

.ad-stat__label {
    font-size: 10px;
    color: #6b7280;
    text-align: center;
    white-space: nowrap;
    line-height: 1.2;
}
/* ── Action row ── */
.ad-action-row { padding: 14px; border-bottom: 0.5px solid #f3f4f6; }
.ad-action-warning {
    font-size: 12px;
    color: #92400e;
    background: #fffbeb;
    border-radius: 8px;
    padding: 8px 10px;
    margin-bottom: 10px;
    line-height: 1.4;
}
.ad-meta-tags { display: flex; gap: 6px; margin-top: 10px; flex-wrap: wrap; }
.ad-meta-tag {
    font-size: 11px;
    color: #6b7280;
    background: #f3f4f6;
    padding: 3px 8px;
    border-radius: 20px;
}

/* ── Accordion ── */
.ad-accordion { border-top: 0.5px solid #f3f4f6; }
.ad-accordion__item { border-bottom: 0.5px solid #f3f4f6; }
.ad-accordion__btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 14px;
    background: none;
    border: none;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    color: #111;
    text-align: left;
    -webkit-tap-highlight-color: transparent;
}
.ad-accordion__btn:active { background: #f9fafb; }
.ad-accordion__right { display: flex; align-items: center; gap: 6px; }
.ad-accordion__badge { font-size: 12px; color: #6b7280; display: inline-flex; align-items: center; gap: 3px; }
.ad-accordion__arrow { color: #9ca3af; flex-shrink: 0; }
.ad-accordion__body { padding: 0 14px 14px; font-size: 13px; color: #374151; line-height: 1.6; }

/* ── Screenshots ── */
.ad-screenshots { display: flex; gap: 8px; overflow-x: auto; padding: 8px 14px 14px; scrollbar-width: none; }
.ad-screenshots::-webkit-scrollbar { display: none; }
.ad-screenshot { height: 180px; width: auto; border-radius: 10px; flex-shrink: 0; }

/* ── Info rows ── */
.ad-info-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;
    border-bottom: 0.5px solid #f9fafb;
    font-size: 13px;
}
.ad-info-row:last-child { border-bottom: none; }
.ad-info-row__label { color: #6b7280; }
.ad-info-row__val { color: #111; font-weight: 500; text-align: right; max-width: 55%; }

/* ── Rating bars ── */
.ad-rating-header { display: flex; align-items: center; justify-content: space-between; margin-bottom: 14px; }
.ad-rating-section-title { display: flex; justify-content: space-between; align-items: center; font-size: 13px; margin-bottom: 10px; }
.ad-rating-bars { display: flex; flex-direction: column; gap: 8px; margin-bottom: 14px; }
.ad-rating-bar-row { display: flex; align-items: center; gap: 8px; font-size: 12px; }
.ad-rating-bar-label { width: 120px; color: #6b7280; flex-shrink: 0; }
.ad-rating-bar-track { flex: 1; height: 6px; background: #f3f4f6; border-radius: 999px; overflow: hidden; }
.ad-rating-bar-fill { height: 100%; background: #2563eb; border-radius: 999px; }
.ad-rating-bar-val { width: 24px; text-align: right; font-size: 11px; color: #6b7280; }

/* ── Review cards ── */
.ad-reviews-scroll { display: flex; gap: 10px; overflow-x: auto; padding-bottom: 10px; scrollbar-width: none; margin-bottom: 10px; }
.ad-reviews-scroll::-webkit-scrollbar { display: none; }
.ad-review-card { min-width: 160px; background: #f9fafb; border-radius: 10px; padding: 10px; flex-shrink: 0; }
.ad-review-card__top { display: flex; justify-content: space-between; align-items: center; margin-bottom: 6px; }
.ad-review-card__score { display: flex; align-items: center; gap: 3px; font-size: 12px; color: #374151; }
.ad-review-card__name { font-size: 12px; color: #374151; margin: 0 0 4px; font-weight: 500; }
.ad-review-card__text { font-size: 11px; color: #6b7280; margin: 0; max-height: 60px; overflow: hidden; }
.ad-review-card__date { font-size: 10px; color: #9ca3af; margin: 4px 0 0; }
.ad-thumbs { display: flex; align-items: center; gap: 12px; font-size: 13px; flex-wrap: wrap; }

/* ── App card (usage tab header) ── */
.ad-app-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    background: #fff;
    border-bottom: 0.5px solid #e5e7eb;
    padding: 14px;
    margin-bottom: 8px;
}
.ad-app-card__left { display: flex; align-items: center; gap: 10px; flex: 1; min-width: 0; }
.ad-app-card__icon { width: 40px; height: 40px; border-radius: 10px; flex-shrink: 0; }
.ad-app-card__info { font-size: 14px; font-weight: 600; color: #111; }
.ad-app-card__right { display: flex; align-items: center; gap: 8px; flex-shrink: 0; }
.ad-app-card__status { font-size: 12px; font-weight: 500; }
.ad-app-card__status--on { color: #16a34a; }
.ad-app-card__status--off { color: #dc2626; }

/* ── Daily limit card ── */
.ad-limit-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 13px 14px 10px;
    border-bottom: 0.5px solid #f3f4f6;
}
.ad-limit-title { font-size: 13px; font-weight: 600; color: #111; display: flex; align-items: center; }
.ad-limit-body {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 14px;
    gap: 12px;
}
.ad-limit-label { font-size: 13px; font-weight: 500; color: #374151; flex: 1; }

/* ── Legend ── */
.ad-legend { display: flex; flex-direction: column; gap: 6px; }
.ad-legend__item { display: flex; align-items: center; gap: 8px; font-size: 12px; color: #374151; }
.ad-legend__dot { width: 10px; height: 10px; border-radius: 50%; flex-shrink: 0; }

/* ── Reuse from dashboard ── */
.apps-card { background: #fff; border-radius: 14px; border: 0.5px solid #e5e7eb; overflow: hidden; }
.kid-action-switch { position: relative; display: inline-flex; width: 38px; height: 20px; cursor: pointer; margin: 0; }
.kid-action-switch input { opacity: 0; width: 0; height: 0; position: absolute; }
.kid-action-switch__track { position: absolute; inset: 0; background: #d1d5db; border-radius: 999px; transition: background 0.2s; }
.kid-action-switch__track::after { content: ''; position: absolute; top: 3px; left: 3px; width: 14px; height: 14px; background: white; border-radius: 50%; transition: transform 0.2s; }
.kid-action-switch input:checked + .kid-action-switch__track { background: #2563eb; }
.kid-action-switch input:checked + .kid-action-switch__track::after { transform: translateX(18px); }

.req-popup__stepper { display: flex; align-items: center; border: 0.5px solid #e5e7eb; border-radius: 10px; overflow: hidden; }
.req-popup__step-btn { width: 36px; height: 36px; background: #f9fafb; border: none; display: flex; align-items: center; justify-content: center; cursor: pointer; -webkit-tap-highlight-color: transparent; }
.req-popup__step-btn:active { background: #f3f4f6; }
.req-popup__step-input { width: 56px; height: 36px; border: none; border-left: 0.5px solid #e5e7eb; border-right: 0.5px solid #e5e7eb; text-align: center; font-size: 14px; font-weight: 600; color: #111; background: #fff; outline: none; }

.req-action-btn { width: 100%; height: 44px; border-radius: 12px; border: none; font-size: 14px; font-weight: 600; cursor: pointer; margin-bottom: 8px; -webkit-tap-highlight-color: transparent; }
.req-action-btn:disabled { opacity: 0.6; cursor: not-allowed; }
.req-action-btn--primary { background: #2563eb; color: #fff; }
.req-action-btn--danger { background: #fee2e2; color: #dc2626; display: flex; align-items: center; justify-content: center; gap: 6px; }

.activity-section { padding: 0 14px; }
.activity-header { padding: 14px 0 4px; }
.activity-header__top { display: flex; align-items: center; justify-content: space-between; margin-bottom: 12px; }
.activity-header__title { font-size: 16px; font-weight: 700; color: #111; margin: 0; }
.activity-header__toggle { display: flex; background: #f3f4f6; border-radius: 10px; padding: 3px; gap: 2px; }
.activity-toggle-btn { border: none; background: transparent; font-size: 13px; font-weight: 500; color: #6b7280; padding: 5px 16px; border-radius: 8px; cursor: pointer; transition: background 0.15s, color 0.15s; -webkit-tap-highlight-color: transparent; }
.activity-toggle-btn--active { background: #fff; color: #111; font-weight: 600; box-shadow: 0 1px 3px rgba(0,0,0,0.08); }
.activity-nav { display: flex; align-items: center; background: #fff; border: 0.5px solid #e5e7eb; border-radius: 12px; padding: 4px 6px; gap: 4px; }
.activity-nav__arrow { width: 36px; height: 36px; display: flex; align-items: center; justify-content: center; background: none; border: none; border-radius: 8px; color: #374151; cursor: pointer; flex-shrink: 0; -webkit-tap-highlight-color: transparent; }
.activity-nav__arrow:active { background: #f3f4f6; }
.activity-nav__date { flex: 1; text-align: center; font-size: 13px; font-weight: 600; color: #111; }
.activity-nav__cal { width: 36px; height: 36px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; color: #374151; }
[data-filter-type="Week"] .activity-nav__cal { opacity: 0.3; pointer-events: none; }

.screentime-card { background: #fff; border-radius: 14px; border: 0.5px solid #e5e7eb; margin: 8px 0; overflow: hidden; }
.screentime-card__header { display: flex; align-items: center; justify-content: space-between; padding: 14px 14px 10px; border-bottom: 0.5px solid #f3f4f6; }
.screentime-card__left { display: flex; flex-direction: column; gap: 2px; }
.screentime-card__label { font-size: 11px; font-weight: 500; color: #6b7280; text-transform: uppercase; letter-spacing: 0.4px; }
.screentime-card__value { font-size: 22px; font-weight: 700; color: #1d4ed8; line-height: 1.1; }
.screentime-card__body { padding: 12px 14px 14px; }

.ps-popup-wrap { padding: 0 0 8px; }
.ps-popup { background: #fff; border-radius: 14px; border: 0.5px solid #e5e7eb; overflow: hidden; }
.ps-popup__header { display: flex; align-items: center; justify-content: space-between; padding: 13px 14px 11px; border-bottom: 0.5px solid #f3f4f6; }
.ps-popup__title { font-size: 14px; font-weight: 700; color: #111; }
.ps-popup__close { width: 28px; height: 28px; border-radius: 50%; background: #f3f4f6; border: none; display: flex; align-items: center; justify-content: center; cursor: pointer; color: #374151; -webkit-tap-highlight-color: transparent; }
.ps-popup__body { padding: 14px; }

.last-updated { display: flex; align-items: center; justify-content: center; gap: 5px; padding: 12px 0 8px; font-size: 12px; color: #9ca3af; }

.ps-install-btn { background: #2563eb; color: #fff; border: none; border-radius: 20px; padding: 6px 14px; font-size: 12px; font-weight: 600; cursor: pointer; -webkit-tap-highlight-color: transparent; }

.save-row { padding-top: 16px; border-top: 0.5px solid #f3f4f6; margin-top: 16px; }
.btn-save { width: 100%; padding: 13px; background: #2563eb; color: #fff; border: none; border-radius: 12px; font-size: 14px; font-weight: 700; cursor: pointer; transition: opacity 0.2s; }
.btn-save:hover:not(:disabled) { opacity: 0.9; }
.btn-save:disabled { opacity: 0.6; cursor: not-allowed; }

/* ── Date picker — unchanged from original ── */
.date-picker-wrapper { position: relative; display: inline-flex; align-items: center; justify-content: center; min-width: 44px; min-height: 44px; cursor: pointer; }
.date-picker-label { display: flex; align-items: center; justify-content: center; width: 100%; height: 100%; margin: 0; cursor: pointer; z-index: 1; position: relative; }
.date-picker-input { position: absolute; top: 0; left: 0; width: 100%; height: 100%; opacity: 0; cursor: pointer; z-index: 10; }
.date-picker-input::-webkit-calendar-picker-indicator { position: absolute; top: 0; left: 0; right: 0; bottom: 0; width: 100%; height: 100%; margin: 0; padding: 0; opacity: 0; cursor: pointer; }
@media (max-width: 768px) { .date-picker-input { font-size: 16px; } }
[data-filter-type="Week"] .date-picker-wrapper { opacity: 0.3; pointer-events: none; cursor: not-allowed; }
[data-filter-type="Week"] .date-picker-input { pointer-events: none; cursor: not-allowed; }
.req-back { width:  100%; text-align: left; }
.tab-content { width: 100%; }
.ps-tab.active,
.ps-tab.ps-tab--active {
    color: #2563eb;
    font-weight: 700;
    border-bottom-color: #2563eb;
}
button:focus {
  outline: unset !important;
}
/* ── Rating Popup ── */
.rating-popup {
    background: #fff;
    border-radius: 16px;
    border: 0.5px solid #e5e7eb;
    overflow: hidden;
    margin: 8px 14px;
}

.rating-popup__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 16px 12px;
    border-bottom: 0.5px solid #f3f4f6;
}

.rating-popup__title {
    font-size: 15px;
    font-weight: 700;
    color: #111;
}

.rating-popup__body {
    padding: 0;
}

.rating-popup__app-row {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 16px;
    background: #f9fafb;
    border-bottom: 0.5px solid #f3f4f6;
}

.rating-popup__app-icon {
    width: 36px;
    height: 36px;
    border-radius: 9px;
    flex-shrink: 0;
}

.rating-popup__app-name {
    font-size: 14px;
    color: #111;
}

/* ── Rating Questions ── */
.rating-popup__questions {
    padding: 4px 0;
}

.rating-q {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 12px 16px;
    border-bottom: 0.5px solid #f9fafb;
}

.rating-q:last-child { border-bottom: none; }

.rating-q__label {
    font-size: 13px;
    font-weight: 500;
    color: #374151;
    flex: 1;
    line-height: 1.4;
    text-align: left;
}

/* ── Thumb buttons ── */
.rating-q__thumb-row {
    display: flex;
    gap: 8px;
    flex-shrink: 0;
}

.rating-thumb-btn {
    padding: 6px 14px;
    border-radius: 20px;
    border: 0.5px solid #e5e7eb;
    background: #f9fafb;
    font-size: 13px;
    font-weight: 500;
    color: #374151;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    transition: all 0.15s;
}

.rating-thumb-btn--active-yes {
    background: #dcfce7;
    border-color: #86efac;
    color: #15803d;
    font-weight: 600;
}

.rating-thumb-btn--active-no {
    background: #fee2e2;
    border-color: #fca5a5;
    color: #dc2626;
    font-weight: 600;
}

/* ── Textarea ── */
.rating-popup__textarea {
    width: 100%;
    border: 0.5px solid #e5e7eb;
    border-radius: 10px;
    padding: 10px 12px;
    font-size: 13px;
    color: #111;
    background: #f9fafb;
    outline: none;
    resize: none;
    line-height: 1.5;
    margin-top: 6px;
    box-sizing: border-box;
}

.rating-popup__textarea:focus {
    border-color: #2563eb;
    background: #fff;
}

/* ── Footer ── */
.rating-popup__footer {
    padding: 12px 16px 16px;
    border-top: 0.5px solid #f3f4f6;
}

/* ── History tab ── */
.ah-filters { display: flex; gap: 6px; padding: 12px 14px 4px; overflow-x: auto; scrollbar-width: none; }
.ah-filters::-webkit-scrollbar { display: none; }
.ah-chip { border: 0.5px solid #e5e7eb; background: #f9fafb; color: #374151; font-size: 12px; font-weight: 500; padding: 5px 12px; border-radius: 20px; white-space: nowrap; cursor: pointer; }
.ah-chip--active { background: #2563eb; border-color: #2563eb; color: #fff; font-weight: 600; }
.ah-empty { padding: 32px 14px; text-align: center; color: #6b7280; font-size: 13px; }
.ah-list { padding: 8px 14px 14px; }
.ah-item { display: flex; align-items: center; gap: 10px; padding: 12px 0; border-bottom: 0.5px solid #f3f4f6; text-align: left; }
.ah-item:last-of-type { border-bottom: none; }
.ah-dot { width: 10px; height: 10px; border-radius: 50%; flex-shrink: 0; }
.ah-dot--on { background: #16a34a; }
.ah-dot--off { background: #dc2626; }
.ah-item__body { flex: 1; min-width: 0; }
.ah-item__title { font-size: 13px; font-weight: 600; color: #111; }
.ah-item__meta { font-size: 11px; color: #6b7280; margin-top: 2px; word-break: break-all; }
.ah-badge { font-size: 10px; font-weight: 600; padding: 3px 8px; border-radius: 20px; flex-shrink: 0; }
.ah-badge--app { background: #eff6ff; color: #2563eb; }
.ah-badge--limit { background: #fffbeb; color: #b45309; }
</style>